<script setup lang="ts">
  import { useScroll } from '@vueuse/core';
  import { ref, onMounted, onUnmounted, nextTick } from 'vue';

  const hasTopOverflow = ref(false);
  const hasBottomOverflow = ref(false);
  const scrollContent = ref<HTMLElement | null>(null);

  const { arrivedState, directions } = useScroll(scrollContent);
</script>

<template>
  <div class="scroll-indicator-container">
    <!-- Top Indicator -->
    <div v-if="!arrivedState.top" class="scroll-indicator top-indicator">
      <div class="indicator-circle">
        <v-icon class="icon">mdi-chevron-up</v-icon>
      </div>
    </div>

    <!-- Scrollable Content -->
    <div ref="scrollContent" class="scroll-content">
      <slot></slot>
    </div>

    <!-- Bottom Indicator -->
    <div v-if="!arrivedState.bottom" class="scroll-indicator bottom-indicator">
      <div class="indicator-circle">
        <v-icon class="icon">mdi-chevron-down</v-icon>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
  .scroll-indicator-container {
    @apply tw-relative tw-w-full tw-h-full tw-flex-1 tw-min-h-1;

    .scroll-content {
      @apply tw-h-full tw-overflow-y-auto;
    }

    .scroll-indicator {
      @apply tw-absolute tw-left-1/2 tw-transform tw--translate-x-1/2 tw-z-10;

      .indicator-circle {
        @apply tw-bg-white tw-ring-1 tw-ring-gray-300 tw-rounded-full tw-w-9 tw-h-9;
        @apply tw-shadow-sm;
        @apply tw-flex tw-items-center tw-justify-center;

        .icon {
          @apply tw-text-blue-500;
        }
      }
    }

    .top-indicator {
      @apply tw-top-1;
    }

    .bottom-indicator {
      @apply tw-bottom-1;
    }
  }
</style>
